import React, { useState, useEffect } from "react";
import TableMain from "../shared/TableMain";
// import completed from "./data/completed.json";
import { TablesMainStyle } from "./styles/TablesMain";

const CompletedJob = ({
  data = [],
  CurrentPage,
  setCurrentPage,
  Last_page,
  total_pages,
}) => {
  const [OrdersData, SetOrdersData] = useState([]);

  useEffect(() => {
    if (data && data?.length > 0) {
      const modifiedData = data?.map((values) => {
        const Sender = values?.stops[0]?.contact_name;
        // const PickupLocation = values?.stops[0]?.location?.address || "";s
        const order_id = values?.order_id;
        const created_at = values?.created_at;
        const Receiver = values?.stops[1]?.contact_name;

        const Order = values?.stops[0]?.order_detail?.name;
        // const order_type = values?.order_type;
        const Price = values?.price;
        const status = values?.status;
        const Driver = values?.driver_name;
        const DriverPrice = values?.driver_price;

        // Remove the "stops" array from the object using destructuring
        // const { stops, ...modifiedValues } = values;

        return {
          // ...modifiedValues,
          order_id,
          created_at,
          Sender,
          Receiver,
          Order,
          // order_type,
          Driver,
          Price,
          DriverPrice,
          status,
        };
      });

      // Update the OrdersData state with the modified array
      SetOrdersData(modifiedData || []);
    }
  }, [data]);

  const TableHeadData = [
    { title: "ID", val: "ID" },
    { title: "Date & Time", val: "DateTime" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Order", val: "Order" },
    { title: "Driver", val: "Driver" },
    { title: "Customer Price", val: "Customer Price" },
    { title: "Driver Price", val: "DriverPrice" },
    { title: "Status", val: "status" },
  ];
  return (
    <>
      <TablesMainStyle>
        {OrdersData?.length > 0 && (
          <TableMain
            TableHeadData={TableHeadData}
            BodyData={OrdersData}
            Hasaction={false}
            CurrentPage={CurrentPage}
            setCurrentPage={setCurrentPage}
            Last_page={Last_page}
            total_pages={total_pages}
            TableType="job/complete"
          />
        )}
      </TablesMainStyle>
    </>
  );
};

export default CompletedJob;
